import palette from "../palette";

const MuiCard = {
    styleOverrides: {
        root: {
            borderRadius: '16px',
            background: palette.common.white,
            boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.05), 0px 6px 13px 0px rgba(0, 0, 0, 0.05), 0px 24px 24px 0px rgba(0, 0, 0, 0.04), 0px 54px 33px 0px rgba(0, 0, 0, 0.03), 0px 97px 39px 0px rgba(0, 0, 0, 0.01), 0px 151px 42px 0px rgba(0, 0, 0, 0.00)'
        }
    }
};

export default MuiCard;
